import styled from "styled-components"

export const Span = styled.span`
  color: ${(props) => (props.color ? props.color : "inherit")};
  ${(props) => props.flex && `display: flex`};
  ${(props) => props.flexColumn && `flex-direction: column`};
  ${(props) => props.spaceBetween && `justify-content: space-between`};
  ${(props) => props.bold && `font-weight: bold`};
  ${(props) => props.semiBold && `font-weight: 600`};
  ${(props) => props.light && `font-weight: 300`};
  ${(props) => props.weight && `font-weight: ${props.weight}`};
  ${(props) => props.opacity && `opacity: ${props.opacity}`};
  ${(props) => props.fontStyle && `font-style: ${props.fontStyle}`};
  ${(props) => props.size && `font-size: ${props.size}`};
  ${(props) => props.lineHeight && `line-height: ${props.lineHeight}`};
  ${(props) => props.leftSpace && `margin-left: ${props.leftSpace}`};
  ${(props) => props.rightSpace && `margin-right: ${props.rightSpace}`};
  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.mt && `margin-top: ${props.mt}px`};
  ${(props) => props.mb && `margin-bottom: ${props.mb}px`};
  ${(props) => props.mr && `margin-right: ${props.mr}px`};
  ${(props) => props.ml && `margin-left: ${props.ml}px`};
  ${(props) => props.m0 && "margin: 0px"};
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth}`};
  ${(props) => props.align && `text-align: ${props.align}`};
  ${(props) => props.lineThrough && "text-decoration: line-through"};
  ${(props) => props.underline && "text-decoration: underline"};
  ${(props) => props.decoration && `text-decoration: ${props.decoration}`};
  ${(props) => props.center && "text-align: center"};
  ${(props) =>
    props.letterSpacing && `letter-spacing: ${props.letterSpacing}px`};
  ${(props) => props.padding && `padding: ${props.padding}`};
  ${(props) => props.height && `height: ${props.height}`};
  ${(props) => props.width && `width: ${props.width}`};
  @media (max-width: 520px) {
    ${(props) => props.mMargin && `margin: ${props.mMargin};`}
    ${(props) => props.mCenter && `text-align: center;`}
    ${(props) => props.mWidth && `width: ${props.mWidth};`}
    ${(props) => props.mHeight && `height: ${props.mHeight};`}
  }

  @media (max-width: 346px) {
    ${(props) => props.smMargin && `margin: ${props.smMargin};`}
    ${(props) => props.smCenter && `text-align: center;`}
    ${(props) => props.smWidth && `width: ${props.smWidth};`}
    ${(props) => props.smHeight && `height: ${props.smHeight};`}
  }
`

export default Span
